<script>
    import {activityDetail} from "@/utils/api/build";
    import {getActivityCode,getShareLink} from "@/utils/api/activity";
    import { imageUrl } from "@/utils/config/commonUrl.js";
    import copyrightConfig from "@/utils/config/changeCopyright.js";
    import appConfig from "@/app.config";
    export default {
        page: {
            title: "创建成功",
            meta: [{ name: "description", content: appConfig.description }]
        },
        data() {
            return {
                imageUrl: imageUrl,
                qrCodeUrl: '', // 这里需要设置实际的二维码图片地址
                imgOssSrc: 'http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/',
                activityId: '',
                selectType: '',
                isType: '',
                pageType: '',
                is_template: '',
                groupId: '',
                activityDetail: {},
                shareTitle: '',
                cloneLianJie: false, //控制分享链接弹窗
                folderId: '',
                isInFolder: '',
                JumpUrl: '',
                codeUrl: '',
                routeParameter: '', // 链接参数
            }
        },
        created() {
            document.body.classList.remove("auth-body-bg");
        },
        mounted() {
            // 页面参数
            this.routeParameter = this.$route.query;
            this.activityId = this.routeParameter.id;
            this.selectType = this.routeParameter.selectType;
            this.isType = this.routeParameter.isType;
            this.pageType = this.routeParameter.pageType;
            this.is_template = this.routeParameter.is_template;
            this.groupId = this.routeParameter.groupId;
            this.isInFolder = this.routeParameter.isInFolder;
            this.folderId = this.routeParameter.folderId;
            this._getActivityInfo()
            this.getActivityCode()
            // 确保标题设置生效
            this.$nextTick(() => {
                this.setPageTitle();
            });
        },
        methods: {
            // 设置页面标题
            setPageTitle() {
                // 根据 AppID 确定后缀
                let suffix = '接龙加加';
                if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
                    suffix = '报名管家';
                }

                document.title = `创建成功 - ${suffix}`;
                console.log(document.title, "document.title");
            },
            // 获取活动信息数据接口
            async _getActivityInfo() {
                let obj = {
                    "activityId": this.activityId,
                    "selectType": this.selectType,
                }
                if (this.is_template == 1) { //通过模板进来
                    obj = {
                        "templateIsShow": '99',
                        "templateId": this.activityId,
                        "selectType": this.selectType,
                    }
                } else {
                    obj = {
                        "activityId": this.activityId,
                        "selectType": this.selectType,
                    }
                }
                obj["is_template"] = this.is_template;
                const {
                    data,
                    msg,
                    status
                } = await activityDetail(obj)
                if (status == 1) {
                    console.log(data,'看看数据呀')
                    this.activityDetail = data.activityDetail;
                }

            },
            // 获取二维码
            getActivityCode(row) {
                let scene = "id=" + this.activityId + "&st=see&ity=" + this.activityDetail.activity_type;
                getActivityCode({
                    activityId: this.activityId,
                    page: "pages/solataireGroupDetails/solataireGroupDetails",
                    scene: scene,
                }).then((res) => {
                    console.log(res, "获取二维码");

                    if (res.status == 1) {
                        this.codeUrl = this.imageUrl + res.data.smallCode;
                    }
                });

                getShareLink({ activityId: this.activityId }).then((res) => {
                    if (res.status == 1) {
                        this.JumpUrl = res.data.shareLink;
                    }
                });
            },
            downLoadCodePic(url) {
                this.downloadIamge(url, new Date().valueOf());
            },

            //
            downloadIamge(imgsrc, name) {
                // 下载图片地址和图片名
                var image = new Image();
                // 解决跨域 Canvas 污染问题
                image.setAttribute("crossOrigin", "Anonymous");
                image.onload = function () {
                    var canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;
                    var context = canvas.getContext("2d");
                    context.fillStyle = "#FFFFFF";
                    context.fillRect(0, 0, canvas.width, canvas.height);
                    context.drawImage(image, 0, 0, image.width, image.height);
                    var url = canvas.toDataURL("image/png"); // 得到图片的base64编码数据
                    var a = document.createElement("a"); // 生成一个a元素
                    var event = new MouseEvent("click"); // 创建一个单击事件
                    a.download = name || "photo"; // 设置图片名称
                    a.href = url; // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event); // 触发a的单击事件
                };
                image.src = imgsrc;
            },
        },
    };
</script>

<template>
    <div>
        <div class="home-btn d-none d-sm-block">
            <a href="/" class="text-dark">
                <i class="mdi mdi-home-variant h2"></i>
            </a>
        </div>
        <div class="my-5 pt-sm-5">
            <div class="container">
                <div class="row mainBox">
                    <div class="col-12 text-center">
                        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bs-success.svg" alt="success" class="success-icon mb-4">
                        <h4 class="mb-3">创建成功</h4>
                        <div class="basic-info mb-4">
                            <span class="me-2">返回接龙详情</span>
                        </div>
                        <div class="invited">
                            <p class="text-muted mb-4">邀请其他人参加活动</p>
                            <div class="link-box">{{ JumpUrl }}</div>
                        </div>

                        <div class="qr-code-wrapper">
                            <img :src="codeUrl" alt="QR Code" class="qr-code mb-3">
                            <div class="downQr" @click="downLoadCodePic(codeUrl)">下载二维码</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.mainBox {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 58vh;

    .success-icon {
        width: 80px;
        height: 80px;
    }

    .qr-code {
        width: 200px;
        height: 200px;
    }
    .basic-info .me-2{
        width: 130px;
        height: 32px;
        border: 1px solid #1877ff;
        border-radius: 18px;
        text-align: center;
        line-height: 32px;
        color: #1877ff;
        display: inline-block;
    }
    .text-center{
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        align-items: center;
    }
    .invited{
        width: 300px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: center;
        align-items: flex-start;
        margin-bottom: 15px;
    }
    .text-muted{
        font-weight: bold;
        color: black !important;
        margin-bottom: 10px !important;
    }
    .link-box{
        width: 100%;
        height: 41px;
        background: #ffffff;
        border: 0.5px solid #dcdde0;
        border-radius: 4px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
        padding-left: 10px;
        font-size: 13px;
        text-align: left;
        color: #7e7e81;
    }
    .downQr{
        width: 92px;
        height: 36px;
        background: #1877ff;
        border: 0.51px solid #1877ff;
        border-radius: 18px;
        font-size: 12px;
        color: #ffffff;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
    }
    .qr-code-wrapper{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}
</style>
